import { STATIC_IMAGES_URL } from "@hey/data/constants";

const Hero = () => {
  return (
    <div
      className="relative h-64 w-full gap-y-5 rounded-none bg-black md:rounded-xl"
      style={{
        backgroundImage: `url(/bg2.png)`,
        backgroundPosition: "center",
        backgroundSize: "cover"
      }}
    >
      <div className="absolute bottom-5 left-5">
        <div className="font-extrabold text-3xl text-white">
          Welcome to Relayr
        </div>
      <div className="font-extrabold text-gray-200">
  {/* a social network built on Lens */}
  Created with love, by {" "}
<a
  href="https://x.com/shivabajpai"
  target="_blank"
  rel="noopener noreferrer"
  className="relative font-serif bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent font-medium after:content-['✦'] after:absolute after:-right-4 after:text-yellow-300 after:animate-pulse"
>
  @Shiva Bajpai.
</a>

</div>
      </div>
    </div>
  );
};

export default Hero;
